<div id="td-wb-symbol-lookup-wrap-aria"
     class="td-wb-symbol-lookup"
     [class.td-wb-symbol-lookup--disabled]="disabled()"
     [class.td-wb-symbol-lookup--active]="isActive()">
  <span class="td-wb-symbol-lookup-wrap"
        cdk-overlay-origin
        #connectedOverlayOrigin="cdkOverlayOrigin">
    <div id="td-wb-symbol-lookup-live-aria"
         class="td-wb-vh"
         aria-live="polite"
         [innerHTML]="focusOnInput() && showRecentSearchState() ? ('tdWb.components.symbolLookup.RECENT_SEARCH_ACCESSIBILITY' | tdWbTranslate) : ''">
    </div>
    <td-wb-new-typeahead #typeAhead
                         class="td-wb-symbol-lookup-wrap__typeahead td-wb-symbol-lookup-input"
                         type="text"
                         autocomplete="off"
                         [uppercase]="true"
                         [id]="name()"
                         [name]="name() + '_symbolOrNameInput'"
                         [aria-label]="('tdWb.trading.inputLabels.SYMBOL_LOOKUP' | tdWbTranslate)"
                         [ngModel]="symbolInput()"
                         [ngModelOptions]="{ standalone: true }"
                         (onSelect)="onSelectSymbol($event, 'dropdown')"
                         (ngModelChange)="inputChange($event)"
                         [placeholder]="(placeholderKey() ?? 'tdWb.components.symbolLookup.PLACEHOLDER') | tdWbTranslate"
                         [preSelectFirstItem]="preSelectFirstItem()"
                         (focus)="setRecentSearches(typeAhead?.value())"
                         (blur)="inputBlur()"
                         [disabled]="disabled()"
                         [overrideOverlayOrigin]="connectedOverlayOrigin">
      @if (showRecentSearchState()) {
        <div class="td-wb-symbol-lookup-recent-search-label"
             translate="tdWb.components.symbolLookup.RECENT_SEARCH"
             [attr.aria-label]="'tdWb.components.symbolLookup.RECENT_SEARCH' | tdWbTranslate">
        </div>
      }
      @let typeAheadValue = typeAhead.value();
      @for (item of symbols(); track (item.symbol ?? '') + '_' + (item.market ?? '') + '_' + (item.marketType ?? '')) {
        <td-wb-item [value]="item">
            <ng-container [ngTemplateOutlet]="customTemplate() ?? defaultTypeAheadTemplate"
                          [ngTemplateOutletContext]="{ $implicit: item, inputValue: typeAheadValue }"/>
            <ng-template #defaultTypeAheadTemplate
                         let-item
                         let-inputValue="inputValue">
              <td-wb-symbol-lookup-item-label [item]="item"
                                              [highlight]="inputValue"
                                              [compact]="compactSymbolLabel()"/>
            </ng-template>
          </td-wb-item>
      }
      </td-wb-new-typeahead>
    <span class="td-wb-symbol-lookup-search-button">
         <button tdWbIconButton
                 tdWbIconButtonShape="circle"
                 tdWbIconButtonSize="extra-small"
                 [attr.id]="name() + '_search-button'"
                 [name]="name() + '_searchButton'"
                 [attr.aria-label]="'tdWb.components.symbolLookup.SEARCH' | tdWbTranslate"
                 [disabled]="disabled()"
                 (click)="onSymbolButtonClicked()"
                 [attr.readonly]="disabled()">
        <td-wb-icon size="16"
                    iconId="search"/>
      </button>
      </span>
    </span>
</div>
